export default "__VITE_ASSET__BmGQ9FkP__"